/**
 * L'enveloppe decoupled a DEUX formes, et c'est le DROIT D'ÉCRITURE qui décide :
 *
 *  - écriture accordée → objet Syncable, contenu imbriqué sous `data` :
 *    `{item_url, submission_url, delete_url, data: {id, type, objectData, …}}`
 *  - lecture seule      → réponse À PLAT : `{item_url, id, type, objectData, …}`
 *
 * La règle vaut à tous les niveaux (page, bloc, unité) ; `normalizePage` la
 * applique déjà pour la page et ses blocs. Ce module la porte pour tout ce qui
 * lit une entité decoupled hors de ce chemin — le montage d'une unité par
 * référence (`UnitMount`) et la copie d'un bloc partagé.
 *
 * Le piège qu'elle évite : parier sur `data` marche pour un éditeur et échoue
 * pour un visiteur anonyme — un bloc qui s'affiche parfaitement en édition et
 * ne rend RIEN une fois la page publiée.
 */
export const unwrapDecoupled = (payload) => (
  payload?.data && typeof payload.data === 'object' && !Array.isArray(payload.data)
    ? payload.data
    : (payload ?? {})
)
